 
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import page from "../../../smartpak/page";

var promotionStatusType = {
    NOTHING: 0,
    DEFAULT: 1,
    QUALIFIED: 2,
    NOT_QUALIFIED: 3
};

function FreeShipBannerViewModel(data) {
    ko.mapping.fromJS(data, {}, this);

    this.FreeShipStatus = ko.observable(data.FreeShipStatus);
    this.dollarsShortOfQualifying = ko.observable(data.DollarsShortOfQualifying.toFixed(2));
    this.isNotQualified = ko.observable(this.FreeShipStatus() === promotionStatusType.NOT_QUALIFIED);
    this.isDefault = ko.observable(this.FreeShipStatus() === promotionStatusType.DEFAULT);
    this.isQualified = ko.observable(this.FreeShipStatus() === promotionStatusType.QUALIFIED);
    this.isNothing = ko.observable(this.FreeShipStatus() === promotionStatusType.NOTHING);
    this.isMobile = page.isMobile();
    this.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive = ko.observable(data.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive);
    this.hasSubTotalGreatThanZero = ko.observable(this.CartSubTotal() > 0);

    this.FreeShipStatus.subscribe(
        function(status) {
            this.isNotQualified(status === promotionStatusType.NOT_QUALIFIED);
            this.isDefault(status === promotionStatusType.DEFAULT);
            this.isQualified(status === promotionStatusType.QUALIFIED);
            this.isNothing(status === promotionStatusType.NOTHING);
        }.bind(this)
    );
}

FreeShipBannerViewModel.prototype.update = function(vm) {
    this.FreeShipStatus(vm.FreeShipStatus);
    this.SmartPerksFreeMessageWarningCssClass(vm.SmartPerksFreeMessageWarningCssClass);
    this.SmartPerksFreeMessageCssClass(vm.SmartPerksFreeMessageCssClass);
    this.dollarsShortOfQualifying(vm.DollarsShortOfQualifying.toFixed(2));
    this.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive(vm.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive);
    this.hasSubTotalGreatThanZero(vm.CartSubTotal > 0);
};

export default FreeShipBannerViewModel;

